import { render, staticRenderFns } from "./RecordDetails.vue?vue&type=template&id=e001e100&scoped=true&"
import script from "./RecordDetails.vue?vue&type=script&lang=js&"
export * from "./RecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./RecordDetails.vue?vue&type=style&index=0&id=e001e100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e001e100",
  null
  
)

export default component.exports